import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from '../../config/reduxIndex';
import PageWrapper from '../../components/shared/PageWrapper';
import Users from '../../components/users/Users';

class UsersContainer extends Component {
	componentWillMount() {
		const { setUserDefault } = this.props;
		setUserDefault();
	}

	render() {
		const { match, openNewUser } = this.props;
		const { newUser } = this.props.user;
		const tableProps = this.tablePropsInit()
		return <PageWrapper
			match = { match }
		>
			<Users 
				tableProps = { tableProps }
				cancelEditable = { this.cancelEditable }
				newUser = { newUser }
				toggleNewUser = { openNewUser }
				cancelNewUser = { this.cancelNewUser }
			/>
		</PageWrapper>;
	}

	tablePropsInit = () => {
		const { update, reloadTable, rowIndex, expandedRowIds } = this.props.user;
		const row = this.props.user;
		const { reloadTriggered, updateTriggered } = this.props;
		return {
			selection: expandedRowIds,
			expandedRowIds: expandedRowIds,
			onSelectionChange: this.selectionChange,
			reload: reloadTable,
			reloadTriggered,
			updateTriggered,
			update,
			rowIndex,
			row
		}
	}

	cancelNewUser = () => {
		const { setUserDefault } = this.props;
		setUserDefault()
	}

	cancelEditable = () => {
		const { setExpandedRowIds } = this.props;
		setExpandedRowIds([])
	};

	selectionChange = (selArray) => {
		const { setExpandedRowIds, user } = this.props;
		const currentSelected = user.expandedRowIds;
		let newState = [];
		if(currentSelected.length === 0) {
			newState = selArray;
		} else {
			newState = selArray.slice(1)
		}
		this.selectRowIndex(newState);
		setExpandedRowIds(newState);
	}

	selectRowIndex = (newState) => {
		const { selectRowIndex, setUserDefault } = this.props;
		if(newState.length === 0) {
			setUserDefault();
		} else {
			selectRowIndex(newState[0]);
		}
	}
}
function mapStateToProps(state) {
	return {
		user: state.user
	}
}

const mapDispatchToProps = dispatch => {
	return {
		openNewUser: () => {
			const changeObj = {
				newUser: true
			}
			dispatch(actions.user.setDefault());
			dispatch(actions.user.setAttributeByObj(changeObj));
		},
		updateTriggered: () => {
			const changeObj = {
				update: null
			}
			dispatch(actions.user.setAttributeByObj(changeObj));
		},
		reloadTriggered: () => {
			const changeObj = {
				'reloadTable': false
			}
			dispatch(actions.user.setAttributeByObj(changeObj));
		},
		selectRowIndex: (rowIndex) => {
			const changeObj = {
				rowIndex
			}
			dispatch(actions.user.setAttributeByObj(changeObj));
		},
		setUserDefault: () => {
			dispatch(actions.user.setDefault());
		},
		setExpandedRowIds: (arr) => {
			const changeObj = {
				expandedRowIds: arr
			}
			dispatch(actions.user.setAttributeByObj(changeObj));
		}
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(UsersContainer);


// WEBPACK FOOTER //
// ./src/containers/users/UsersContainer.jsx